import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="url(#paint0_linear_11378_10492)"/>
    <g clip-path="url(#clip0_11378_10492)">
    <path d="M23.1998 16H14.3998M23.1998 16L20.7998 13.6M23.1998 16L20.7998 18.4M18.7998 10.4C18.0735 9.33338 16.9648 8.80005 14.1392 8.80005C10.2855 8.80005 8.7998 11.2 8.7998 15.9999C8.7998 20.8 10.2855 23.2 14.1391 23.2C16.9648 23.2 18.0735 22.6667 18.7998 21.6" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_11378_10492" x1="5.78914" y1="1.79084" x2="9.37082" y2="22.2126" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FFC2EB"/>
    <stop offset="1" stop-color="#FF4E4E"/>
    </linearGradient>
    <clipPath id="clip0_11378_10492">
    <rect width="19.2" height="19.2" fill="white" transform="translate(6.3999 6.40002)"/>
    </clipPath>
    </defs>
    </svg>

  );
};


export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

